import { useEffect, useState } from "react";

import { config } from "@sso/config";
import { Dialog } from "@sso/constant";
import { useAppDispatch, useAppSelector } from "@sso/hooks/useRedux";
import { useToggleBodyOverflow } from "@sso/hooks/useToggleBodyOverflow";
import { detachDialog, selectDialog } from "@sso/store/slices/dialog";
import { ColumnContainer } from "@sso/ui/FlexBox";

import { DialogContainer, DialogOverlay } from "./components/DialogLayout";
import { dialogsObject } from "./dialogsObject";

export const Dialogs = () => {
  const dispatch = useAppDispatch();
  const [open, setOpen] = useState<boolean>(false);
  const dialog = useAppSelector(selectDialog);

  useToggleBodyOverflow(open);

  useEffect(() => {
    if (!dialog.close && dialog.type !== Dialog.CLOSE) {
      return setOpen(true);
    }
    setOpen(false);
    const timer = setTimeout(() => {
      dispatch(detachDialog());
    }, config.dialogFadeInOut);
    return () => clearTimeout(timer);
  }, [dialog.close, dialog.type, dispatch]);

  const dialogObject = dialogsObject[dialog.type];

  if (dialog.type === Dialog.CLOSE) {
    return null;
  }

  return (
    <>
      <DialogOverlay opacity={open ? 0.6 : 0} bgColor="black" />
      <DialogOverlay opacity={open ? 1 : 0}>
        <DialogContainer maxWidth={dialogObject.maxWidth}>
          <ColumnContainer>
            <dialogObject.component />
          </ColumnContainer>
        </DialogContainer>
      </DialogOverlay>
    </>
  );
};
